<template>
  <div class="modal fade" id="discount-modal" tabindex="-1" aria-labelledby="discount-modal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{$t('discount')}}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="close"></button>
        </div>
        <div class="modal-body">
          <input v-model.number="localDiscount" type="number" max="100" min="0" class="form-control mb-3" placeholder="Enter discount amount..." />
          <div class="d-flex flex-wrap gap-2 justify-content-center">
            <button 
              v-for="val in predefinedDiscounts" 
              :key="val" 
              type="button" 
              class="btn btn-sm"
              :class="localDiscount === val ? 'btn-primary' : 'btn-outline-secondary'"
              @click="localDiscount = val">
              {{ val }}%
            </button>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{$t('cancel')}}</button>
          <button type="button" class="btn btn-primary" @click="saveDiscount"><AppIcon name="bi-check-circle" class="bi bi-check-circle me-2" />{{$t('save')}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiscountModal',
  props: {
    state: {
      type: Boolean,
      required: true
    },
    discount: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      createModal: null,
      localDiscount: this.discount,
      predefinedDiscounts: [5, 10, 25, 50, 75, 100]
    };
  },
  mounted() {
    // eslint-disable-next-line no-undef
    this.createModal = new bootstrap.Modal(document.getElementById('discount-modal'))
    if (this.state === true) {
      this.createModal.show()
    }

    document.getElementById('discount-modal').addEventListener('hidden.bs.modal', () => {
      this.$emit('saveDiscount', { state: false })
    })
  },
  methods: {
    saveDiscount() {
      this.$emit('saveDiscount', { discount: this.localDiscount });
      this.createModal.hide();
    }
  }
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}
.modal {
  background: white;
  border-radius: 5px;
  max-width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}
.modal-header, .modal-footer {
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
}
.modal-header {
  border-bottom: none;
}
.modal-body {
  padding: 1rem;
}
</style>
